<template>
    <b-modal ref='emailVerificationModal' centered :no-close-on-esc='true' :no-close-on-backdrop='true' :hide-header-close='true' cancel-title='' v-on:ok='checkEmailVerificationCode'>
        <p>{{ $t("translations.email_verification_text") }}:</p>
        <ul class='mt-3'><li>{{item.email}}</li></ul>
        <p>{{ $t("translations.email_verification_code") }}</p>
        <input type='text' class='form-control' maxlength='4' v-model='item.email_verification_code' />
        <inline-error v-bind:errors='errors' type='email_verification_code'></inline-error>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-left" variant="info" v-on:click.prevent='$refs.emailVerificationModal.hide()'>
                {{ $t("translations.change_email_address") }}
            </b-btn>
            <b-btn size="sm" class="float-right" variant="success" v-on:click.prevent='checkEmailVerificationCode'>
                {{ $t("translations.verify_email_address") }}
            </b-btn>
        </div>
    </b-modal>        
</template>

<script>

export default {

    props: {
        'route': {default: '/api/vp1/patients'},
        'item': {
            default: () => {return {}}
        }
    },
    data: function() {
        return {
            errors: []
        };
    },
    mounted() {
        this.errors = [];
    },
    methods: {
        show() {
            this.$refs.emailVerificationModal.show()
        },
        getEmailVerificationCode() {
            return axios.post(this.route + '/createEmailVerificationCode', {email: this.item.email}).then((res) => {
                this.setLoading(false);
                this.$refs.emailVerificationModal.show();
            }).catch((error) => {
                this.setLoading(false);
                this.handleError(error, "create email verification");
            });
        },
        checkEmailVerificationCode(event) {
            this.$refs.emailVerificationModal.hide()
            this.setLoading(true);
            return axios.post(this.route + '/verifyEmailCode', this.item).then((res) => {
                this.setLoading(false);
                this.$refs.emailVerificationModal.hide()
                this.$emit("validated");
            }).catch((error) => {
                this.setLoading(false);
                this.$refs.emailVerificationModal.show()
                this.handleError(error, "create");
            });
        },
    }
}

</script>
